<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content ? `${content}` : `CouponBirds` }}</template>
  </metainfo>
  <Header/>
  <div class="body" style=" max-width: 1440px;margin: auto;">
    <el-row class="row-bg home-body" justify="center">
      <el-col :span="10">
        <div class="home-body-left">
          <div class="home-body-h2">Ultimate Roblox WebKit</div>
          <div class="home-body-text">FREE Roblox extension to improve gaming experience for all players. Free themes and backgrounds! Free server filter! </div>
          <template v-if="browser === 'Firefox'">
            <a :href="download_url">
              <div class="home-body-button" style="position: absolute;bottom: 100px;" @click="logClick('download1_Main')">Add to {{browser}} -&nbsp;
                <span style="font-size: 23px"> It's Free</span>
              </div>
            </a>
          </template>
          <template v-else>
            <div class="home-body-button" style="position: absolute;bottom: 100px;" @click="logClick('download1_Main')">Add to {{browser}} -&nbsp;
              <span style="font-size: 23px"> It's Free</span>
            </div>
          </template>
          <div class="home-body-star" style="position: absolute;bottom: 50px;">
            <svg width="20px" height="20px" viewBox="0 0 23 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="pag1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon fill="#FFCD0A" points="11.5 18.0987026 4.7404696 20.8036954 5.22426092 13.5391112 0.562850063 7.94630456 7.62137995 6.16153748 11.5 0 15.3786201 6.16153748 22.4371499 7.94630456 17.7757391 13.5391112 18.2595304 20.8036954"></polygon>
              </g>
            </svg>
            <svg width="20px" height="20px" viewBox="0 0 23 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="pag1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon fill="#FFCD0A" points="11.5 18.0987026 4.7404696 20.8036954 5.22426092 13.5391112 0.562850063 7.94630456 7.62137995 6.16153748 11.5 0 15.3786201 6.16153748 22.4371499 7.94630456 17.7757391 13.5391112 18.2595304 20.8036954"></polygon>
              </g>
            </svg>
            <svg width="20px" height="20px" viewBox="0 0 23 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="pag1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon fill="#FFCD0A" points="11.5 18.0987026 4.7404696 20.8036954 5.22426092 13.5391112 0.562850063 7.94630456 7.62137995 6.16153748 11.5 0 15.3786201 6.16153748 22.4371499 7.94630456 17.7757391 13.5391112 18.2595304 20.8036954"></polygon>
              </g>
            </svg>
            <svg width="20px" height="20px" viewBox="0 0 23 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="pag1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon fill="#FFCD0A" points="11.5 18.0987026 4.7404696 20.8036954 5.22426092 13.5391112 0.562850063 7.94630456 7.62137995 6.16153748 11.5 0 15.3786201 6.16153748 22.4371499 7.94630456 17.7757391 13.5391112 18.2595304 20.8036954"></polygon>
              </g>
            </svg>
            <svg width="20px" height="20px" viewBox="0 0 23 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="pag1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon fill="#FFCD0A" points="11.5 18.0987026 4.7404696 20.8036954 5.22426092 13.5391112 0.562850063 7.94630456 7.62137995 6.16153748 11.5 0 15.3786201 6.16153748 22.4371499 7.94630456 17.7757391 13.5391112 18.2595304 20.8036954"></polygon>
              </g>
            </svg>
            <span style="font-size:25px">
            5-star rating
          </span>
          </div>
        </div>
      </el-col>
      <el-col :span="10">
        <el-carousel height="415px" arrow="always" style="width: 560px;margin: auto" indicator-position="outside" interval="1200">
          <el-carousel-item>
            <img class="right_img" src="https://cdn.rokit.gg/web-img/home/new2.png">
          </el-carousel-item>
          <el-carousel-item>
            <img class="right_img" src="https://cdn.rokit.gg/web-img/home/new1.png">
          </el-carousel-item>
          <el-carousel-item>
            <img class="right_img" src="https://cdn.rokit.gg/web-img/home/new3.png">
          </el-carousel-item>
          <el-carousel-item>
            <img class="right_img" src="https://cdn.rokit.gg/web-img/home/new4.png">
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
    <el-row class="row-bg home-body-order" justify="center">
      <el-col :span="20">
        <div class="order-title">Our Features</div>
        <order-cart></order-cart>
        <div class="plans-background"></div>
      </el-col>
    </el-row>
    <el-row class="row-bg home-body-h3-div" justify="center">
      <el-col :span="20">
        <span class="home-body-h3">What Our Users Are Saying </span>
      </el-col>
    </el-row>
    <el-row class="row-bg home-body-h3-div" justify="center">
      <el-col :span="20" style="min-height: 360px">
        <el-carousel type="card" arrow="always" width="100%" interval="2000">
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment1.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment2.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment3.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment4.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment5.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment6.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment7.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment8.png" style="height: 280px">
          </el-carousel-item>
          <el-carousel-item>
            <img class="logo_img" src="https://cdn.rokit.gg/web-img/home/comment9.png" style="height: 280px">
          </el-carousel-item>
        </el-carousel>
        <template v-if="browser === 'Firefox'">
          <a :href="download_url">
            <div class="home-body-button" style="margin: 5% auto 0;"  @click="logClick('download1_Main2')">Add to {{browser}} -&nbsp;
              <span style="font-size: 25px"> It's Free</span>
            </div>
          </a>
        </template>
        <template v-else>
          <div class="home-body-button" style="margin: 5% auto 0;"  @click="logClick('download1_Main2')">Add to {{browser}} -&nbsp;
            <span style="font-size: 25px"> It's Free</span>
          </div>
        </template>
      </el-col>
    </el-row>
  </div>
  <Footer/>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Cookies from "js-cookie";
import {useMeta} from "vue-meta";
import {sendActionLog} from "@/js/common";
import OrderCart from "@/components/giveAway/OrderCart";
import {downloadUrl} from "@/js/config";
export default {
  name: 'HomeView',
  components: {
    OrderCart,
    Footer,
    Header,
  },
  props:{
    browser:String,
    toStore:Function,
  },
  setup(){
    let download_url = downloadUrl
    useMeta({
      title: 'RoKit.gg - Ultimate Roblox WebKit | Free Roblox Extension ',
      meta: [
        {
          property: "og:description",
          content:
              "RoKit is a free browser extension that adds useful features to Roblox."
        },
        {
          property: "og:image",
          content:
              "https://cdn.rokit.gg/rokit_share2.jpg"
        },
        {
          property: "og:title",
          content:
              "RoKit - Explore More Fun on Roblox"
        },
      ],
      description: 'RoKit is a free browser extension that adds useful features to Roblox. Useful Roblox features which improve Roblox gaming experiences, Make Roblox easy to play. Roblox Enhancer, enhances your Roblox website experiences.',
    })
    return {download_url}
  },
  methods:{
    async logClick(flag) {
      sendActionLog(flag,true);
    },
    setRef(){
      let url = window.location.href;
      let arr = url.split('ref=')
      let ref = false
      if (arr.length > 1){
        let arr2 = arr[1].split('&')
        if (arr2){
          ref = arr2[0]
        }else
          ref = arr
      }
      if (ref){
        Cookies.set('roKitRef',ref,{domain:'rokit.gg'})
      }
    },
    setStyle(){
      let ul_list = document.querySelectorAll('.el-carousel__button')
      for (let i = 0;i<ul_list.length;i++) {
        ul_list[i].style.width= '20px'
        ul_list[i].style.height= '20px'
        ul_list[i].style.borderRadius= '20px'
        ul_list[i].style.display= 'block'
        if (i > 3){
          ul_list[i].style.display = 'none'
        }
      }
    }
  },
  beforeMount() {
    let robots = document.querySelector('meta[name="robots"]')
    if (robots) robots.remove()
    let meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'nofollow'
    let head = document.querySelector('head')
    if (head) head.appendChild(meta)
  },
  mounted() {
    if (window.location.hash && window.location.hash.indexOf('subscribe') !== -1){
      window.scrollTo({
        top: 500,
        behavior: "instant"
      });
    }
    let removeItems = document.getElementsByClassName('el-carousel__mask');
    for (let i = 0; i < removeItems.length; i++) {
      removeItems[i].style.backgroundColor = '#1f2427'
    }
    this.setRef()

    let arrow_list = document.getElementsByClassName('el-carousel__arrow')
    for (let i = 0; i < arrow_list.length; i++) {
      arrow_list[i].style.display = 'none'
      arrow_list[i].style.width = '50px'
      arrow_list[i].style.height = '300px'
      arrow_list[i].style.backgroundColor = 'rgb(31 45 61 / 0%)'

    }
    let icon_list = document.getElementsByClassName('el-icon')
    for (let i=0;i<icon_list.length;i++){
      let svg = icon_list[i].children
      if (i < 4){
        if (svg){
          icon_list[i].style.width='3rem'
          icon_list[i].style.height='3rem'
        }
      }else {
        if (svg){
          icon_list[i].style.display='none'
        }
      }
    }

    this.setStyle()
    setTimeout(this.setStyle,500)
    setTimeout(this.setStyle,1000)
    setTimeout(this.setStyle,2000)
    setTimeout(this.setStyle,5000)
  }
}
</script>
<style scoped lang="scss">
.home-body{
  margin-top: 3%;
}
.order-title{
  margin: 5% auto;
  text-align: center;
  font-size: 34px;
  font-weight: 700;
  color: #fff
}
.home-body-button{
  cursor: pointer;
  margin-top: 35px;
  width: 351px;
  height: 70px;
  display: flex;
  color: #ffffff;
  font-size: 30px;
  font-weight: 600;
  align-items: center;
  border-radius: 8px;
  background-image: linear-gradient(to bottom, #f3473a, #e2221b);
  justify-content: center;
}
.right_img{
  height: 415px;
}
.home-body-left{
  color: #ffffff;
  .home-body-h1{
    font-size: 105px;
  }
  .home-body-h2{
    margin-top: 25px;
    font-size: 50px;
  }
  .home-body-text{
    line-height: 40px;
    font-size: 22px;
    width: 70%;
    margin-top: 30px;
  }
  .home-body-star{
    margin-top: 3%;
    width: 351px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    svg{
      margin: 0px 1px;
    }
  }
}
.home-body-text2-div{
  margin-top: 5%;
  text-align: center;
  .home-body-text2{
    font-size: 20px;
    margin-top: 5%;
  }
}
.home-body-h3-div{
  margin: 3% 0px;
  text-align: center;
  .home-body-h3{
    font-size: 35px;
    color: #ffffff;
  }
}
.plans-background{
  background-color: #141516;
  height: 570px;
  margin-top: -510px;
  border-radius: 51px
}
</style>

